
import { Link } from 'react-router-dom'
import './plans.css'

const services = [
  {
    number: '01',
    title: 'Investigación social y demográfica',
    description:
      'Estudios de población, envejecimiento, migraciones, pobreza y desigualdad para comprender los cambios sociales y territoriales.',
    tags: ['Demografía', 'Investigación social', 'Indicadores']
  },
  {
    number: '02',
    title: 'Análisis territorial y SIG',
    description:
      'Análisis espacial de fenómenos sociales, construcción de indicadores territoriales y elaboración de cartografía temática.',
    tags: ['SIG', 'Cartografía', 'Análisis espacial']
  },
  {
    number: '03',
    title: 'Estadística, ciencia de datos e IA',
    description:
      'Procesamiento de grandes bases de datos, modelamiento estadístico, aprendizaje automático y análisis predictivo.',
    tags: ['R y Python', 'Machine Learning', 'Big Data']
  },
  {
    number: '04',
    title: 'Evaluación de políticas públicas',
    description:
      'Diagnósticos, evaluación de intervenciones, focalización territorial y simulación de escenarios para apoyar decisiones.',
    tags: ['Evaluación', 'Focalización', 'Simulación']
  },
  {
    number: '05',
    title: 'Visualizaciones y plataformas interactivas',
    description:
      'Desarrollo de tableros, aplicaciones analíticas y herramientas de exploración de datos para instituciones e investigadores.',
    tags: ['Dashboards', 'R Shiny', 'Visualización']
  },
  {
    number: '06',
    title: 'Capacitación y formación especializada',
    description:
      'Formación aplicada en programación estadística, análisis de datos, visualización e investigación social cuantitativa.',
    tags: ['Docencia', 'R', 'Metodología']
  }
]

const methods = [
  {
    number: '01',
    title: 'Diagnóstico',
    description:
      'Comprendemos el problema, sus objetivos y su contexto institucional y territorial.'
  },
  {
    number: '02',
    title: 'Análisis',
    description:
      'Integramos fuentes de información y aplicamos metodologías cuantitativas rigurosas.'
  },
  {
    number: '03',
    title: 'Resultados',
    description:
      'Transformamos los hallazgos en indicadores, visualizaciones y recomendaciones.'
  },
  {
    number: '04',
    title: 'Transferencia',
    description:
      'Entregamos herramientas y conocimiento para facilitar el uso de los resultados.'
  }
]

const Plans = () => {
  return (
    <main className="demografica-services">
      <section className="services-hero">
        <div className="services-hero__inner">
          <p className="services-eyebrow">
            DEMOGRÁFICA · CONSULTORÍA
          </p>

          <h1>
            Conocimiento aplicado para
            <span> decisiones mejor informadas.</span>
          </h1>

          <p className="services-hero__description">
            Combinamos investigación social, estadística,
            ciencia de datos y análisis territorial para
            responder a desafíos de instituciones públicas,
            organizaciones y proyectos de investigación.
          </p>

          <div className="services-hero__actions">
            <Link to="/contact" className="services-btn services-btn--primary">
              Solicitar una consultoría →
            </Link>

            <Link to="/censo" className="services-btn services-btn--secondary">
              Explorar nuestra plataforma
            </Link>
          </div>
        </div>

        <div className="services-hero__visual" aria-hidden="true">
          <div className="services-visual">
            <span>INVESTIGACIÓN · DATOS · TERRITORIO</span>
            <div className="services-visual__graphic">
              <div className="services-visual__ring services-visual__ring--one" />
              <div className="services-visual__ring services-visual__ring--two" />
              <div className="services-visual__ring services-visual__ring--three" />
              <div className="services-visual__center" />
            </div>
            <strong>Inteligencia social y territorial</strong>
            <small>Evidencia para comprender y transformar</small>
          </div>
        </div>
      </section>

      <section className="services-intro">
        <p className="services-eyebrow">NUESTRAS ESPECIALIDADES</p>
        <h2>
          Soluciones construidas desde
          <span> la evidencia.</span>
        </h2>
        <p>
          Cada proyecto requiere una aproximación propia.
          Articulamos conocimiento sociológico, métodos
          cuantitativos y herramientas tecnológicas para
          producir resultados claros, útiles y fundamentados.
        </p>
      </section>

      <section className="services-catalog" aria-label="Áreas de consultoría">
        {services.map(({ number, title, description, tags }) => (
          <article className="services-card" key={number}>
            <span className="services-card__number">{number}</span>
            <h3>{title}</h3>
            <p>{description}</p>
            <div className="services-card__tags">
              {tags.map(tag => <span key={tag}>{tag}</span>)}
            </div>
          </article>
        ))}
      </section>

      <section className="services-feature">
        <div className="services-feature__content">
          <p className="services-eyebrow">CAPACIDADES ANALÍTICAS</p>
          <h2>
            Del dato a la comprensión del territorio.
          </h2>
          <p>
            Trabajamos con fuentes oficiales, información
            geoespacial y metodologías reproducibles para
            estudiar fenómenos sociales a diferentes escalas.
          </p>
          <Link to="/censo" className="services-btn services-btn--primary">
            Conocer Censo 2024 →
          </Link>
        </div>

        <div className="services-feature__panel">
          <span>DEMOGRÁFICA · ANÁLISIS APLICADO</span>
          <strong>Datos que revelan desigualdades.</strong>
          <p>
            Indicadores · Cartografía · Modelos · Escenarios
          </p>
        </div>
      </section>

      <section className="services-methodology">
        <div className="services-methodology__heading">
          <p className="services-eyebrow">CÓMO TRABAJAMOS</p>
          <h2>Rigor metodológico, resultados útiles.</h2>
        </div>

        <div className="services-methodology__grid">
          {methods.map(({ number, title, description }) => (
            <article key={number}>
              <span>{number}</span>
              <h3>{title}</h3>
              <p>{description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="services-cta">
        <div>
          <p className="services-eyebrow">TRABAJEMOS JUNTOS</p>
          <h2>Conversemos sobre tu proyecto.</h2>
          <p>
            Podemos ayudarte a transformar preguntas complejas
            en investigaciones, indicadores y herramientas
            para la toma de decisiones.
          </p>
        </div>

        <Link to="/contact" className="services-btn services-btn--light">
          Contactar →
        </Link>
      </section>
    </main>
  )
}

export default Plans

